import { useParams } from 'react-router-dom'
import { useGetObjectiveAccessByIdQuery } from '@/store/api/aggregatesApi'

export const useHasAccessContentAfterCompletion = () => {
  const { objectiveId = '' } = useParams<{ objectiveId: string }>()
  const { data: objectiveAccess } = useGetObjectiveAccessByIdQuery(objectiveId, { skip: !objectiveId })

  return objectiveAccess?.accessNewContentAfterCompletion
}
